// Um banner na lista do painel: pre-visualizacao na proporcao real (3:1),
// switch de ativo, setas de ordem e remover.

import { ArrowDown, ArrowUp, Film, Trash2 } from "lucide-react";

import { Switch } from "../../../components/ui/switch";
import { bannerImageUrl } from "../lib/bannerImageUrl";

export default function BannerCard({
  banner, posicao, total, onToggle, onRemover, onMover,
}) {
  const inativo = !banner.enabled;

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      {/* Preview na mesma proporção do cardápio — o lojista vê o recorte real
          que o cliente vai receber, não uma miniatura quadrada que mente. */}
      <div className={`relative w-full aspect-[7/2] bg-muted ${inativo ? "opacity-40" : ""}`}>
        {banner.media_type === "video" ? (
          <>
            <video
              src={bannerImageUrl(banner.image_url)}
              poster={bannerImageUrl(banner.poster_url)}
              className="w-full h-full object-cover"
              muted loop playsInline autoPlay preload="metadata"
            />
            <span className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-black/70 text-white text-[11px] font-semibold">
              <Film className="w-3 h-3" /> Vídeo
            </span>
          </>
        ) : (
          <img
            src={bannerImageUrl(banner.image_url)}
            alt={banner.title || `Banner ${posicao + 1}`}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        )}
        {inativo && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-black/70 text-white text-[11px] font-semibold">
            Pausado
          </span>
        )}
      </div>

      <div className="flex items-center gap-3 p-3">
        <span className="text-xs font-semibold text-muted-foreground tabular-nums w-6">
          {posicao + 1}º
        </span>

        <div className="flex items-center gap-1">
          <BotaoOrdem
            icon={ArrowUp}
            label="Mover para cima"
            disabled={posicao === 0}
            onClick={() => onMover(banner, -1)}
          />
          <BotaoOrdem
            icon={ArrowDown}
            label="Mover para baixo"
            disabled={posicao === total - 1}
            onClick={() => onMover(banner, 1)}
          />
        </div>

        <div className="flex items-center gap-2 ml-auto">
          <span className="text-xs text-muted-foreground">
            {banner.enabled ? "No ar" : "Pausado"}
          </span>
          <Switch
            checked={!!banner.enabled}
            onCheckedChange={() => onToggle(banner)}
            aria-label={banner.enabled ? "Pausar banner" : "Ativar banner"}
          />
        </div>

        <button
          type="button"
          onClick={() => onRemover(banner)}
          aria-label="Remover banner"
          title="Remover banner"
          className="w-9 h-9 rounded-lg flex items-center justify-center text-muted-foreground hover:text-destructive hover:bg-destructive/10 transition-colors"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

function BotaoOrdem({ icon: Icon, label, disabled, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
      className="w-8 h-8 rounded-lg flex items-center justify-center text-muted-foreground hover:bg-muted disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
    >
      <Icon className="w-4 h-4" />
    </button>
  );
}
